module.exports = __webpack_public_path__ + "img/wechat_tip.cd200bff.png";